import styled, { css } from 'styled-components';

export const Container = styled.div`
  padding: 0px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 18px 12px 18px;
  h3 {
    color: ${props => props.theme.main.color};
    font-size: 26px;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
    margin-bottom: 0;
  }
`;

export const Body = styled.div`
  padding: 0 18px 24px 18px;
`;

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

type TableTitleProps = {
  isTop?: boolean;
};

export const TableTitle = styled.div<TableTitleProps>`
  background-color: ${props => props.theme.main.color};
  border-left: 1px solid ${props => props.theme.main.color};
  border-right: 1px solid ${props => props.theme.main.color};

  color: white;
  display: flex;
  font-size: 16px;
  font-weight: 700;
  justify-content: center;
  padding: 12px;
  text-transform: uppercase;

  ${({ isTop }) =>
    isTop &&
    css`
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    `}
`;

export const TableHeader = styled.div`
  border-left: 1px solid #dddddd;
  border-right: 1px solid #dddddd;
  color: ${props => props.theme.main.color};
  display: flex;
  font-weight: 700;
  padding-top: 12px;
  padding-bottom: 12px;
  text-transform: uppercase;
`;

type TableRowProps = {
  offwhite?: boolean;
  lastLine?: boolean;
};

export const TableRow = styled.div<TableRowProps>`
  background-color: ${props => (props.offwhite ? '#F3F3F3' : 'white')}
  border-left: 1px solid #dddddd;
  border-right: 1px solid #dddddd;
  display: flex;
  padding-top: 12px;
  padding-bottom: 12px;

  ${({ lastLine }) =>
    lastLine &&
    css`
      border-bottom: 1px solid #dddddd;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
    `}
`;

type TableItemNameProps = {
  width?: string;
};

export const TableItemName = styled.div<TableItemNameProps>`
  width: ${props => props.width || '40%'};
  padding-left: 16px;
  font-size: 12px;
  display: flex;
  align-items: center;
`;

export const TableItemAssistance = styled.div`
  width: 20%;
  display: flex;
  justify-content: center;
  font-size: 12px;
`;

export const ContainerImage = styled.div`
  display: flex;
  margin-top: 25px;
  justify-content: center;
`;

type LogoProps = {
  width?: string;
};

export const Logo = styled.img<LogoProps>`
  width: ${props => props.width || '200px'};
`;
